import LegalLayout, { H2 } from "@/components/site/LegalLayout";
import { COMPANY } from "@/data/content";

export default function AGB() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen" description="AGB der Schössow Dienstleistungen UG – Hausnotruf.">
      <H2>§ 1 Geltungsbereich</H2>
      <p>Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen der {COMPANY.name} (nachfolgend „Anbieter“) und ihren Kundinnen und Kunden über die Bereitstellung, Installation und den Betrieb von Hausnotrufsystemen sowie damit verbundene Dienstleistungen.</p>

      <H2>§ 2 Vertragsgegenstand</H2>
      <p>Gegenstand des Vertrages ist die Überlassung eines Hausnotrufgeräts (Basisstation und Funksender) sowie die Anbindung an eine 24-Stunden-Notrufzentrale. Der konkrete Leistungsumfang ergibt sich aus dem jeweiligen Angebot bzw. der Auftragsbestätigung.</p>

      <H2>§ 3 Vertragsschluss</H2>
      <p>Die Darstellung der Leistungen auf dieser Website stellt kein bindendes Angebot dar. Ein Vertrag kommt erst durch eine ausdrückliche Auftragsbestätigung des Anbieters oder durch Ausführung der Leistung zustande.</p>

      <H2>§ 4 Leistungen & Verfügbarkeit</H2>
      <p>Der Anbieter bemüht sich um eine hohe Verfügbarkeit des Notrufsystems. Eine 100-prozentige Verfügbarkeit kann jedoch – insbesondere bei Strom-, Netz- oder Leitungsausfällen, die nicht im Verantwortungsbereich des Anbieters liegen – nicht garantiert werden.</p>

      <H2>§ 5 Preise & Zahlung</H2>
      <p>Es gelten die im Angebot bzw. in der Auftragsbestätigung genannten Preise. Sofern ein Pflegegrad vorliegt, kann unter bestimmten Voraussetzungen ein Zuschuss der Pflegekasse in Betracht kommen; hierzu beraten wir Sie individuell.</p>

      <H2>§ 6 Pflichten des Kunden</H2>
      <p>Der Kunde verpflichtet sich, das Gerät bestimmungsgemäß zu nutzen, funktionsbeeinträchtigende Veränderungen zu unterlassen und Störungen unverzüglich zu melden. Kontaktdaten von Angehörigen/Notfallkontakten sind aktuell zu halten.</p>

      <H2>§ 7 Haftung</H2>
      <p>Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper und Gesundheit. Im Übrigen ist die Haftung auf die Verletzung wesentlicher Vertragspflichten und auf den vertragstypischen, vorhersehbaren Schaden begrenzt.</p>

      <H2>§ 8 Widerrufsrecht</H2>
      <p>Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Einzelheiten ergeben sich aus der gesonderten Widerrufsbelehrung, die vor Vertragsschluss zur Verfügung gestellt wird.</p>

      <H2>§ 9 Schlussbestimmungen</H2>
      <p>Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>

      <p className="text-sm italic">Hinweis: Diese AGB sind eine anpassbare Vorlage und ersetzen keine Rechtsberatung. Bitte vor Verwendung anwaltlich prüfen lassen.</p>
    </LegalLayout>
  );
}
